import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectBuildingInfoById, selectSelectedBuildingInfo, } from "../../../../selectors/selectExistingBuildingInfo";
import { actionBuildingsSelect } from "../../../player-base/buildings/actionBuildings";
import { TypeActionProductionInfo } from "../actionProductionInfo";
export var epicProductionAddOrUpdate = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionProductionInfo.Add ||
            action.type === TypeActionProductionInfo.Update;
    }), switchMap(function (action) {
        var state = state$.value;
        var buildingId = action.buildingId;
        var selectedBuilding = selectSelectedBuildingInfo(state);
        if (selectedBuilding && selectedBuilding.proto.id === buildingId) {
            var updatedBuildingInfo = selectBuildingInfoById(state, buildingId);
            if (updatedBuildingInfo) {
                return of(actionBuildingsSelect(updatedBuildingInfo));
            }
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionAddOrUpdate.ts
// module id = 1935
// module chunks = 3